export function calculate年間労災保険料(
  給付基礎日額: number, //3,500円〜25,000円の間の16段階
  労災保険料率: number,
): number {
  const 年間労災保険料: number = Math.floor(給付基礎日額 * 365 * 労災保険料率);
  return 年間労災保険料;
}